/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: loading-elements-ids.ts
 * Project: mle-client
 * Committed last: 2021/11/11 @ 1741
 * ---
 */

/**
 * Evita l'utilizzo di stringhe hard-coded per la gestione degli identificativi
 * degli elementi che possono essere in stato di caricamento nell'work-area.
 * @enum
 */
export enum LoadingElementsIds {
  LOGIN,
  LOGOUT,
  CREATE_PROJECT,
  BOARD_USER
}
